export const errorMap = {
  required: 'Bu alan zorunludur.',
  minLength: 'Eksik karakter girdiniz.',
  maxLength: 'Fazla karakter girdiniz.',
  minNumber: 'Daha büyük bir rakam girmelisiniz.',
  maxNumber: 'Daha küçük bir rakam girmelisiniz.',
  alphaNumneric: 'Sadece harf ve rakam girebilirsiniz.',
  alphaOnly: 'Sadece harf girebilirsiniz.',
  alphaSpace: 'Sadece harf ve boşluk girebilirsiniz.',
  number: 'Sadece rakam girebilirsiniz.',
  email: 'E-posta adresinizi hatalı girdiniz..',
  phone: 'Telefon numaranızı hatalı girdiniz..',
  citizenshipNumber: 'Vatandaşlık numaranızı hatalı girdiniz.',
  eighteen: 'Üyelik için en az 18 yaşında olmalısınız.',
  date: 'Tarih bilgisini kontrol edin.',
  contract: 'Üyelik sözleşmesini kabul etmelisiniz.',
  minLengthMembershipNumber: 'Üye numaran 8 haneli olmalı.',
  minLengthCitizenshipNumber: 'T.C. Kimlik numaran 11 haneli olmalı.',
  foreignCitizenshipNotAllowed: 'Yasal düzenlemeler gereği, yabancı kimlik numarasına sahip üyelik işlemlerine geçici süreyle hizmet verilememektedir.'
};
